<div class="container-fluid g-0 m-0">
  <div class="d-flex g-0 m-0">
    <div class="sidemenu-nav background-color">
      <h6 class="sidemenu-title">
        {{ "ACCOUNT_SETTINGS" | translate }}
      </h6>
      <div
        class="sidemenu-item-font item"
        (click)="navigate('account/profile')"
        [ngClass]="{ selected: isActive('account/profile') }"
      >
        <span>{{ "PROFILE" | translate }}</span>
      </div>
      @if(authService.isAuthorized([PermissionEnum.Personalize_view])){
        <div
          class="sidemenu-item-font item"
          (click)="navigate('account/appearance')"
          [ngClass]="{ selected: isActive('account/appearance') }"
        >
          <span>{{ "APPEARANCE" | translate }}</span>
        </div>
      }
      @if(authService.isAuthorized([PermissionEnum.Personalize_modify])){
        <div
          class="sidemenu-item-font item"
          (click)="navigate('account/language')"
          [ngClass]="{ selected: isActive('account/language') }"
        >
          <span>{{ "LANGUAGE" | translate }}</span>
        </div>
      }
      <div
        class="sidemenu-item-font item"
        (click)="isModalOpen = true"
      >
        <span>{{ "LOGOUT" | translate }}</span>
      </div>
    </div>
    <div class="sidemenu-content">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>

<app-confirm-dialog *ngIf="isModalOpen" titleKey="LOGOUT" question="LOGOUT_MODAL"
  (confirm)="logOut()" (cancel)="isModalOpen = false"></app-confirm-dialog>
